var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3V21H18C18 21 19 21 19 22C19 23 18 23 18 23H9L8.7959 22.9893C7.85435 22.8938 7.1062 22.1457 7.01074 21.2041L7 21V3C7 1.89543 7.89543 1 9 1H18C18 1 19 1 19 2C19 3 18 3 18 3H9Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9287 4.92872C17.3191 4.53829 17.9522 4.53849 18.3428 4.92872L24.707 11.293C25.0976 11.6835 25.0976 12.3165 24.707 12.707L18.3428 19.0713C17.9522 19.4615 17.3191 19.4617 16.9287 19.0713C16.5383 18.6809 16.5385 18.0478 16.9287 17.6572L21.5859 13H10V11H21.5859L16.9287 6.34278C16.5385 5.95223 16.5383 5.31914 16.9287 4.92872Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log_out.2a9c58a52ec904798ea3a08f5480ee22.svg";
export { ForwardRef as ReactComponent };